import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay)
}
var staticRenderFns = []

export { render, staticRenderFns }